import { render, staticRenderFns } from "./status-column-dedicated.vue?vue&type=template&id=809d497e"
import script from "./status-column-dedicated.vue?vue&type=script&lang=js"
export * from "./status-column-dedicated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports